import TemplateNames from './TemplateNames';

export default {
  title: 'Mesaje trimise',
  columns: {
    recipient: 'Destinatar',
    template: 'Șablon',
    status: 'Stare',
    opened: 'Deschis',
    clicked: 'Accesat',
    sent_at: 'Trimis la',
  },
  labels: {
    empty_list: 'Niciun mesaj trimis încă',
    load_failed: 'Nu am putut încărca mesajele trimise. Reîncarcă pagina sau contactează asistența.',
    yes: 'Da',
    no: 'Nu',
    clicked_at: 'Accesat la: {{date}}',
    opened_at: 'Deschis la: {{date}}',
  },
  message_statuses: {
    sent: 'Trimis',
    delivered: 'Livrat',
    failed: 'Eșuat',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
};
